<template>
  <div>

    <DeliveryAreas :delivery-areas="areas"
                   :selected.sync="deliveryArea"
                   :selectedType.sync="deliveryAreaType">
      <template slot="back">
        <span class="bh_back pointer" @click="back" v-if="canGoBack" style="padding-right: 20px; display: inline-flex">
            <img :src="require('@/assets/img/facebook/back_str.svg')" alt="back">
        </span>
      </template>
    </DeliveryAreas>

  </div>
</template>

<script>
  import {
    SET_GUARD_AREA_ID, SET_GUARD_AREA_TYPE_ID,
    SET_GUARD_CITY_ID
  } from '@/store/mutations.type'
  import {GUARD_BACK, GUARD_GET_CITIES, GUARD_NEXT, SET_AREA} from '@/store/actions.type'
  import DeliveryAreas from '@/components/Default/Guard/DeliveryAreas'

  export default {
    name: 'Area',
    components: {DeliveryAreas},
    data() {
      return {
        deliveryArea: null,
        deliveryAreaType: null
      }
    },

    computed: {
      areas() {
        return this.$store.getters.guardAreas.filter(area => area.cities.includes(this.$store.getters.guardCityID))
      },
      canGoBack() {
        return this.$store.getters.guardModeInitial === this.$store.getters.guardModes.GUARD_MODE_CITY || this.$store.getters.guardModeInitial === this.$store.getters.guardModes.GUARD_MODE_ORDER_TYPE_AND_OUTLETS
      }
    },

    watch: {
      deliveryArea(deliveryArea) {
        this.onUpdateAreaData(deliveryArea)
      }
    },

    updated() {
      this.onUpdateAreaData(this.deliveryArea)
    },

    methods: {
      async back() {
        this.onUpdateAreaData(null)
        await this.$store.dispatch(GUARD_BACK)
      },
      async next() {
        await this.$store.commit(SET_GUARD_AREA_ID, this.deliveryArea)
        await this.$store.commit(SET_GUARD_AREA_TYPE_ID, this.deliveryAreaType)
        await this.$store.dispatch(SET_AREA, {
          deliveryArea: this.deliveryArea ? this.deliveryArea.id : null,
          deliveryAreaType: this.deliveryAreaType ? this.deliveryAreaType.id : null
        })
        await this.$store.dispatch(GUARD_NEXT)
      },
      onUpdateAreaData(deliveryArea) {
        this.$emit('update:areaData', deliveryArea)
      }
    },

    async mounted() {
      if (!Number(this.$store.getters.guardAreaID)) {
        this.deliveryArea = this.$store.getters.guardAreaID
      }
      this.deliveryAreaType = this.$store.getters.guardAreaTypeID
      if (this.areas.length === 0 && this.$store.getters.guardModeInitial === this.$store.getters.guardModes.GUARD_MODE_AREA) {
        await this.next()
      }
    }

  }
</script>
